"use client";
import { MainTitle } from "@/components/common/MainTitle";
import ProductCard from "@/components/products/ProductCard";
import { IProduct } from "@/lib/interface";
import React, { useState } from "react";
import { BiChevronRight } from "react-icons/bi";

const ProductList: React.FC<{ products: IProduct[] ; country:string}> = ({ products , country}) => {
  const [all, setAll] = useState(false);
  return (
    <section className="md:py-[80px] py-[50px] px-[20px]">
      <div className="container">
        <MainTitle title={"Products"} />
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
          {all
            ? products?.map((p) => <ProductCard key={p.ProductID} {...p} country={country} />)
            : products
                ?.slice(0, 6)
                ?.map((p) => <ProductCard key={p.ProductID} {...p} country={country} />)}
        </div>
        {!all && (
          <div className="flex justify-center mt-5">
            <button
              type="button"
              onClick={() => setAll(true)}
              className=" group overflow-y-hidden mt-5 md:mt-0 bg-white py-3 px-6 border  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-0 hover:before:translate-y-12 before:transition-all before:w-full before:h-full before:rounded-full"
            >
              <p className="relative flex items-center text-white hover:text-orange-main group-hover:text-orange-main  ">
                View More Products <BiChevronRight className="text-xl" />
              </p>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductList;
